// extracted by mini-css-extract-plugin
export var reviewContainer = "review-container_DyT3HptUWj_RMRwU0ejR";
export var scimNote = "scim-note_mYbNx_Xr4XzbGGnguePL";
export var statusSuccess = "status-success_VDbKfDUH2tM2I9YoyBrJ";
export var summaryCard = "summary-card_aK2f_uZSKqrTh_8HfDz6";
export var summaryHeading = "summary-heading_KAe73owWYlaChB_vZr6o";
export var summaryLabel = "summary-label_HO83OuLbWNeA539grDZJ";
export var summaryRow = "summary-row_x3AHpye1wLPij9JSZNTs";
export var summaryValue = "summary-value_WkYIlbB9V0dEZ6195GdG";
export var toggleCard = "toggle-card_FTVDnlFfC3qG8eKrx8YQ";
export var toggleDescription = "toggle-description_Wd7LnI3OE0PC58yBt5lR";
export var toggleRow = "toggle-row_ybcEDB4_83ghhBaOsFE2";
export var warningBanner = "warning-banner_BqyH4VVHTwANz5zzp4I4";
export var warningText = "warning-text_DVBFrMNVHFbbZu5SY5vP";
export var warningTitle = "warning-title_ruUiXaoc3Z2HVm0Amql7";